module.exports = __webpack_public_path__ + "img/yishi7.c33a2fe1.jpg";